<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
  v-card.neutral200
    v-card-text.neutral700--text.pa-8(outlined)
      v-row(justify="center")
        v-col(cols="9")
          div.d-flex.align-center.mb-6
            v-btn.mr-2(icon color="neutral700" @click="closeDialog")
              v-icon(color="neutral700" :size="24") mdi-arrow-left
            .text-2xl.font-semibold Deliverance via WhatsApp
          v-form(ref="form")
            v-card.rounded-lg.content-box(outlined)
              .pa-6
                v-row
                  v-col(cols="7")
                    div.text-md.font-semibold.neutral700--text Whatsapp welcome message
                    div.text-sm.neutral700--text This will be your offer announcement/promotion message
                    v-textarea.text-sm.mt-2.round-xl(ref="textarea" v-model="blast.content" placeholder="Type your message here" outlined rows="6" hide-details="auto" :rules="rules.not_empty" @input="updateCursor" @change="updateCursor" @focus="updateCursor")
                    div.text-sm.font-semibold.neutral700--text.mt-5 Insert field:
                    v-row(no-gutters)
                      v-col.shrink.pr-3.pt-2
                        v-chip(link small outlined color="neutral400" @click="insertValue('offer_name')")
                          span.neutral700--text Offer details
                      v-col.shrink.pr-3.pt-2
                        v-chip(link small outlined color="neutral400" @click="insertValue('recipient_name')")
                          span.neutral700--text Customer name
                      v-col.shrink.pr-3.pt-2
                        v-chip(link small outlined color="neutral400" @click="insertValue('company_name')")
                          span.neutral700--text Clinic’s name
                      v-col.shrink.pr-3.pt-2
                        v-chip(link small outlined color="neutral400" @click="insertValue('company_phone')")
                          span.neutral700--text Phone number
                      v-col.shrink.pr-3.pt-2
                        template(v-if="offer.redeem_method != 'show_message'")
                          v-chip(link small outlined color="neutral400" @click="insertValue('offer_code')")
                            span.neutral700--text Promo code
                  v-divider.neutral300.my-n3(vertical)
                  v-col.pt-0(cols="5")
                    whatsapp-preview(title="Offer message preview" :content="blast.content")

              template(v-if="['First purchase', 'Second purchase'].includes(offer.name)")
                v-divider.neutral300
                div.pa-6
                  div.text-md.font-semibold.neutral700--text Send message after
                  v-row.mt-2(dense)
                    v-col(cols="2")
                      v-text-field.text-sm.round-xl(v-model="blast.auto_send_delay_time_value" placeholder="Enter value" outlined dense height="48" type="number" :rules="rules.not_empty" hide-details="auto")
                    v-col(cols="2")
                      y-select(v-model="blast.auto_send_delay_time_unit" placeholder="Select duration" attach menuPosition="top" :items="duration" item-text="text" item-value="value" :rules="rules.not_empty_select")

    v-divider
    v-card-actions.py-4.px-8.white
      v-spacer
      y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="sm" button-class="px-0" @click="closeDialog")
      y-button(label="Save" text-color="neutral100" color="neutral700" size="sm" dark :loading="isLoading" @click="saveData")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import WhatsappPreview from '@/components/clinic/marketing/WhatsappPreview.vue'

export default {
  components: { WhatsappPreview },
  props: {
    open: {
      type: Boolean,
    },
    blastData: {
      type: Object,
      default: null
    },
    offer: {
      type: Object,
      default: (() => {})
    }
  },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      cursorPosition: 0,
      blast: {},
      duration: [
        { text: 'Seconds', value: 'seconds'},
        { text: 'Minutes', value: 'minutes'},
        { text: 'Hours', value: 'hours'},
        { text: 'Days', value: 'days'},
      ],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      setting: 'marketing/getMarketingSettings'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    textarea () {
      return this.$refs.textarea.$el.querySelector('textarea')
    }
  },
  watch: {
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      if (this.blastData) {
        let blast = JSON.parse(JSON.stringify(this.blastData))
        this.blast = blast
      }
    },
    updateCursor () {
      const postion = this.textarea.selectionStart
      if (!postion) {
        setTimeout(() => {
          this.cursorPosition = this.textarea.selectionStart
        }, 500)
      } else {
        this.cursorPosition = this.textarea.selectionStart
      }
    },
    insertValue (value) {
      let text = ''
      let code = ''
      if (value === 'offer_code' && this.offer.redeem_method === 'general_code') {
        code = this.offer.coupon_code
      } else {
        code = `{{ ${value} }}`
      }
      if (this.blast.content) {
        text = `${this.blast.content} ${code}`
      } else {
        text = code
      }
      this.$set(this.blast, 'content', text)
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      let payload = {
        name: 'Offer message',
        method: 'whatsapp',
        type: 'offer',
        content: this.blast.content,
        send_cue: 'preset',
      }
      if (this.offer.name === 'First purchase') {
        payload.send_cue = 'auto_send_delay',
        payload.auto_send_delay_time_value = this.blast.auto_send_delay_time_value
        payload.auto_send_delay_time_unit = this.blast.auto_send_delay_time_unit
      } else if (this.offer.name === 'Second purchase') {
        payload.send_cue = 'auto_send_delay',
        payload.auto_send_delay_time_value = this.blast.auto_send_delay_time_value
        payload.auto_send_delay_time_unit = this.blast.auto_send_delay_time_unit
      }
      if (this.blast.id) {
        this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${this.blast.id}`, payload)
          .then(() => {
            this.$emit('updated')
            this.closeDialog()
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.$axios.post(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts`, payload)
          .then(() => {
            this.$emit('updated')
            this.closeDialog()
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_complete_request')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) { message = data }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table tbody tr:hover{
    cursor: pointer;
    background: var(--v-neutral200) !important; 
  }
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .search-field {
    .v-input__append-inner {
      margin-top: 12px !important;
    }
  }
}
</style>